// This file is automatically generated by Vocab.
// To make changes update translation.json files directly.

import type { FormatXMLElementFn } from '@vocab/core';
import { createLanguage, createTranslationFile } from '@vocab/core/runtime';

const translations = createTranslationFile<
  'en' | 'id' | 'th',
  {
    'Hi {userEmail}': (values: { userEmail: string }) => string;
    'Not you?': () => 'Not you?' | 'Bukan akun Anda?' | 'ไม่ใช่คุณใช่หรือไม่';
    '<partnerName></partnerName> would like to access your SEEK profile on behalf of <hirerName></hirerName> to prefill this job application.': <
      T = string,
    >(values: {
      partnerName: FormatXMLElementFn<T>;
      hirerName: FormatXMLElementFn<T>;
    }) => ReturnType<FormatXMLElementFn<T>>;
    '<partnerName></partnerName> would like to access your SEEK profile to prefill this job application.': <
      T = string,
    >(values: {
      partnerName: FormatXMLElementFn<T>;
    }) => ReturnType<FormatXMLElementFn<T>>;
    'This includes your career history, skills, default resume, email address and phone number.': () =>
      | 'This includes your career history, skills, default resume, email address and phone number.'
      | 'Ini termasuk riwayat pekerjaan, keterampilan, CV, alamat email, dan nomor telepon Anda.'
      | 'ซึ่งประกอบด้วยประวัติการทำงาน ทักษะ เรซูเม่หลัก อีเมล และหมายเลขโทรศัพท์';
    'This includes your career history, skills, email address and phone number.': () =>
      | 'This includes your career history, skills, email address and phone number.'
      | 'Ini termasuk riwayat pekerjaan, keterampilan, alamat email, dan nomor telepon Anda.'
      | 'ซึ่งประกอบด้วยประวัติการทำงาน ทักษะ อีเมล และหมายเลขโทรศัพท์';
    'Please review your information and make any changes in the next step.': () =>
      | 'Please review your information and make any changes in the next step.'
      | 'Harap tinjau informasi Anda dan buat perubahan di langkah selanjutnya.'
      | 'กรุณาตรวจสอบข้อมูลของคุณ และเปลี่ยนแปลงได้ในขั้นตอนต่อไป';
    'Update profile': () =>
      | 'Update profile'
      | 'Perbarui profil'
      | 'อัปเดตโปรไฟล์';
    'Allow access': () => 'Allow access' | 'Izinkan akses' | 'อนุญาตให้เข้าถึง';
    'Not now': () => 'Not now' | 'Jangan sekarang' | 'ไม่ใช่ตอนนี้';
    'Terms & Conditions': () =>
      | 'Terms & Conditions'
      | 'Syarat & Ketentuan'
      | 'ข้อกำหนดและเงื่อนไข';
    Privacy: () => 'Privacy' | 'Privasi' | 'ความเป็นส่วนตัว';
    'Sorry, we couldn’t prefill your application.': () =>
      | 'Sorry, we couldn’t prefill your application.'
      | 'Maaf, kami tidak dapat mengisi lamaran Anda.'
      | 'ขออภัย เราไม่สามารถกรอกข้อมูลในใบสมัครงานของคุณไว้ล่วงหน้า';
    'Please navigate back to the apply form.': () =>
      | 'Please navigate back to the apply form.'
      | 'Silakan kembali ke formulir lamaran.'
      | 'กรุณากลับไปที่แบบฟอร์มใบสมัคร';
    'Please try again later.': () =>
      | 'Please try again later.'
      | 'Coba lagi nanti.'
      | 'กรุณาลองอีกครั้งภายหลัง';
  }
>({
  en: createLanguage({
    'Hi {userEmail}': 'Hi {userEmail}',
    'Not you?': 'Not you?',
    '<partnerName></partnerName> would like to access your SEEK profile on behalf of <hirerName></hirerName> to prefill this job application.':
      '<partnerName></partnerName> would like to access your SEEK profile on behalf of <hirerName></hirerName> to prefill this job application.',
    '<partnerName></partnerName> would like to access your SEEK profile to prefill this job application.':
      '<partnerName></partnerName> would like to access your SEEK profile to prefill this job application.',
    'This includes your career history, skills, default resume, email address and phone number.':
      'This includes your career history, skills, default resume, email address and phone number.',
    'This includes your career history, skills, email address and phone number.':
      'This includes your career history, skills, email address and phone number.',
    'Please review your information and make any changes in the next step.':
      'Please review your information and make any changes in the next step.',
    'Update profile': 'Update profile',
    'Allow access': 'Allow access',
    'Not now': 'Not now',
    'Terms & Conditions': 'Terms & Conditions',
    Privacy: 'Privacy',
    'Sorry, we couldn’t prefill your application.':
      'Sorry, we couldn’t prefill your application.',
    'Please navigate back to the apply form.':
      'Please navigate back to the apply form.',
    'Please try again later.': 'Please try again later.',
  }),
  id: createLanguage({
    'Hi {userEmail}': 'Hai {userEmail}',
    'Not you?': 'Bukan akun Anda?',
    '<partnerName></partnerName> would like to access your SEEK profile on behalf of <hirerName></hirerName> to prefill this job application.':
      '<partnerName></partnerName> ingin mengakses profil JobStreet by SEEK Anda atas nama <hirerName></hirerName> untuk mengisi lamaran pekerjaan ini.',
    '<partnerName></partnerName> would like to access your SEEK profile to prefill this job application.':
      '<partnerName></partnerName> ingin mengakses profil JobStreet by SEEK Anda untuk mengisi lamaran pekerjaan ini.',
    'This includes your career history, skills, default resume, email address and phone number.':
      'Ini termasuk riwayat pekerjaan, keterampilan, CV, alamat email, dan nomor telepon Anda.',
    'This includes your career history, skills, email address and phone number.':
      'Ini termasuk riwayat pekerjaan, keterampilan, alamat email, dan nomor telepon Anda.',
    'Please review your information and make any changes in the next step.':
      'Harap tinjau informasi Anda dan buat perubahan di langkah selanjutnya.',
    'Update profile': 'Perbarui profil',
    'Allow access': 'Izinkan akses',
    'Not now': 'Jangan sekarang',
    'Terms & Conditions': 'Syarat & Ketentuan',
    Privacy: 'Privasi',
    'Sorry, we couldn’t prefill your application.':
      'Maaf, kami tidak dapat mengisi lamaran Anda.',
    'Please navigate back to the apply form.':
      'Silakan kembali ke formulir lamaran.',
    'Please try again later.': 'Coba lagi nanti.',
  }),
  th: createLanguage({
    'Hi {userEmail}': 'เรียน {userEmail}',
    'Not you?': 'ไม่ใช่คุณใช่หรือไม่',
    '<partnerName></partnerName> would like to access your SEEK profile on behalf of <hirerName></hirerName> to prefill this job application.':
      '<partnerName></partnerName> ต้องการเข้าไปที่โปรไฟล์ SEEK ของคุณในนามของ <hirerName></hirerName> เพื่อกรอกข้อมูลใบสมัครงานนี้ไว้ล่วงหน้า',
    '<partnerName></partnerName> would like to access your SEEK profile to prefill this job application.':
      '<partnerName></partnerName> ต้องการเข้าไปที่โปรไฟล์ SEEK ของคุณ เพื่อกรอกข้อมูลใบสมัครงานนี้ไว้ล่วงหน้า',
    'This includes your career history, skills, default resume, email address and phone number.':
      'ซึ่งประกอบด้วยประวัติการทำงาน ทักษะ เรซูเม่หลัก อีเมล และหมายเลขโทรศัพท์',
    'This includes your career history, skills, email address and phone number.':
      'ซึ่งประกอบด้วยประวัติการทำงาน ทักษะ อีเมล และหมายเลขโทรศัพท์',
    'Please review your information and make any changes in the next step.':
      'กรุณาตรวจสอบข้อมูลของคุณ และเปลี่ยนแปลงได้ในขั้นตอนต่อไป',
    'Update profile': 'อัปเดตโปรไฟล์',
    'Allow access': 'อนุญาตให้เข้าถึง',
    'Not now': 'ไม่ใช่ตอนนี้',
    'Terms & Conditions': 'ข้อกำหนดและเงื่อนไข',
    Privacy: 'ความเป็นส่วนตัว',
    'Sorry, we couldn’t prefill your application.':
      'ขออภัย เราไม่สามารถกรอกข้อมูลในใบสมัครงานของคุณไว้ล่วงหน้า',
    'Please navigate back to the apply form.': 'กรุณากลับไปที่แบบฟอร์มใบสมัคร',
    'Please try again later.': 'กรุณาลองอีกครั้งภายหลัง',
  }),
});

export default translations;
